import React from "react";
import { Link } from "react-router-dom";

const AboutNine = () => {
  return (
    <>
      {/* About area about */}
      
    </>
  );
};

export default AboutNine;
